import React, { useState } from "react";

interface NavbarLocationContextProps {
  set: (path: string) => void;
  path: string;
}

const navbarLocationContextDefault: NavbarLocationContextProps = {
  set: () => {},
  path: "",
};

export const NavbarLocationStateContext =
  React.createContext<NavbarLocationContextProps>(navbarLocationContextDefault);

const NavbarLocationContextFC: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [path, setPath] = useState("");

  function set(path: string) {
    setPath(path);
  }

  return (
    <NavbarLocationStateContext.Provider value={{ set, path }}>
      {children}
    </NavbarLocationStateContext.Provider>
  );
};

export const useNavbarLocation = () =>
  React.useContext(NavbarLocationStateContext);

export default NavbarLocationContextFC;
